export var SUPPORT_PAGES = [
    {
        page: 'regular-contact',
        slugs: [
            'contact-us-homeexchange',
            'kontaktirajte-nas-homeexchange',
            'kontakt-os-homeexchange',
            'contact-op-homeexchange',
            'contactez-nous-homeexchange',
            'kontakt-homeexchange',
            'contattaci-homeexchange',
            'kontact-oss-homeexchange',
            'contactos-homeexchange',
            'contacto-homeexchange',
            'kontakta-oss-homeexchange'
        ]
    },
    {
        page: 'collection-contact',
        slugs: [
            'contact-us-homeexchange-collection',
            'kontaktirajte-nas-homeexchange-collection',
            'kontakt-os-homeexchange-collection',
            'contact-op-homeexchange-collection',
            'contactez-nous-homeexchange-collection',
            'kontakt-homeexchange-collection',
            'contattaci-homeexchange-collection',
            'kontact-oss-homeexchange-collection',
            'contactos-homeexchange-collection',
            'contacto-homeexchange-collection',
            'kontakta-oss-homeexchange-collection'
        ]
    }
];
